export default {
  'meta': {
    'langName': 'ROMANIAN',
    'lang': 'Română'
  },
  'title': 'RECHEMARE PRODUS COȘ DE BASCHET B900 BOX NBA TARMAK',
  'description': 'Am identificat un risc de cădere a stâlpului la coșul nostru de baschet B900, dacă acesta este utilizat fără manivelă și manipulat.\nPentru siguranța dumneavoastră, întrerupeți imediat orice utilizare fără manivela de reglare a înălțimii instalată.\nSecurizarea produsului dumneavoastră va fi posibilă printr-o procedură simplă și un kit de reparații care vă va fi livrat gratuit.\nAcest site web dedicat rechemării este în prezent în construcție. Acesta vă va ghida prin pașii necesari pentru a efectua această operațiune.\nVă vom informa de îndată ce va fi disponibil (în cursul lunii iulie).',
  'status': 'Translation validated by COUNTRY'
} as const
